var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v(" 粤ICP备17155615号-1")]),_vm._v(". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }